const constants = {
    LANGUAGE: {
        DEFAULT: 'sv',
        SWEDISH: 'sv',
        ENGLISH: 'en',
    },
    THEMES: [
        { label: 'default', value: 'default' },
        { label: 'orange', value: 'orange' },
        { label: 'copper-roof', value: 'copper-roof' },
        { label: 'red-limestone', value: 'red-limestone' },
        { label: 'white-plaster', value: 'white-plaster' },
        { label: 'blue', value: 'blue' },
        { label: 'yellow', value: 'yellow' },
        { label: 'purple', value: 'purple' },
        { label: 'brown', value: 'brown' },
        { label: 'green', value: 'green' },
    ],
    DEFAULT_THEME: 'default',
}

export default constants;